import {useMutation} from '@apollo/react-hooks';

import type {
    SelectCalendarSyncCalendar as SelectCalendarSyncCalendarMutation,
    SelectCalendarSyncCalendarVariables as SelectCalendarSyncCalendarMutationVariables,
} from 'nutshell-graphql-types';

import SELECT_CALENDAR_SYNC_CALENDAR from '../mutations/select-calendar-sync-calendar.graphql';
import GET_CALENDAR_SYNC from '../queries/get-calendar-sync.graphql';

export function useSelectCalendarSyncCalendar(): {
    selectCalendarSyncCalendar: (id: string) => Promise<any>;
    isLoading: boolean;
} {
    const [selectCalendarSyncCalendar, {loading}] = useMutation<
        SelectCalendarSyncCalendarMutation,
        SelectCalendarSyncCalendarMutationVariables
    >(SELECT_CALENDAR_SYNC_CALENDAR);

    return {
        selectCalendarSyncCalendar: (id: string) => {
            return selectCalendarSyncCalendar({
                variables: {calendar: {id, syncType: 'PRIMARY'}},
                update: (proxy, mutationResults) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_CALENDAR_SYNC,
                    });

                    const newCalendars =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.selectCalendarSyncCalendar &&
                        mutationResults.data.selectCalendarSyncCalendar.calendars;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_CALENDAR_SYNC,
                            data: {
                                loggedInUser: {
                                    // @ts-expect-error
                                    ...cacheResult.loggedInUser,
                                    calendarSync: {
                                        // @ts-expect-error
                                        ...cacheResult.loggedInUser.calendarSync,
                                        calendars: newCalendars,
                                        isEnabled: true,
                                    },
                                },
                            },
                        });
                    }
                },
            });
        },
        isLoading: loading,
    };
}
